export default __webpack_public_path__ + "946d407a1a803d18fc5507b4b44bc01b.ttf";